import { styled } from '@mui/material'

import { theme } from 'styles/theme'

export const MetricsGrid = styled('div')(() => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',
  gap: '12px',
  width: '100%',

  [theme.breakpoints.down(560)]: {
    gridTemplateColumns: '1fr',
    gap: '8px'
  }
}))

export const MetricCard = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  padding: '10px 12px',
  borderRadius: '8px',
  border: `1px solid ${theme.palette.neutral[700]}`,
  backgroundColor: 'transparent'
}))

export const MetricTitle = styled('span')(() => ({
  fontSize: '12px',
  fontWeight: 500,
  color: theme.palette.neutral[400],
  lineHeight: 1.3
}))

export const MetricValue = styled('span')(() => ({
  fontSize: '16px',
  fontWeight: 700,
  color: theme.palette.neutral[100],
  lineHeight: 1.2
}))

export const SectionTitle = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  paddingBottom: '8px',
  borderBottom: `1px solid ${theme.palette.neutral[700]}`,
  marginTop: '8px'
}))

export const LinkItem = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '10px 12px',
  borderRadius: '8px',
  border: `1px solid ${theme.palette.neutral[700]}`,
  backgroundColor: theme.palette.neutral[900],

  '&:hover': {
    borderColor: theme.palette.neutral[600]
  }
}))

export const UsageRow = styled('div')<{ removed?: boolean }>(({ removed }) => ({
  display: 'grid',
  gridTemplateColumns: '1.5fr 1fr 1fr 1fr',
  gap: '8px',
  padding: '10px 12px',
  borderRadius: '6px',
  backgroundColor: removed ? `${theme.palette.neutral[800]}80` : 'transparent',
  opacity: removed ? 0.7 : 1,
  alignItems: 'center',

  [theme.breakpoints.down(560)]: {
    gridTemplateColumns: '1fr 1fr',
    gap: '4px'
  }
}))

export const UsageHeader = styled('div')(() => ({
  display: 'grid',
  gridTemplateColumns: '1.5fr 1fr 1fr 1fr',
  gap: '8px',
  padding: '8px 12px',
  borderBottom: `1px solid ${theme.palette.neutral[700]}`,

  [theme.breakpoints.down(560)]: {
    gridTemplateColumns: '1fr 1fr',
    gap: '4px'
  }
}))

export const InfoBox = styled('div')(() => ({
  width: 'auto',
  padding: 12,
  border: '1px solid #EDEBEB',
  borderRadius: '5px'
}))

export const InfoRow = styled('div')(() => ({
  display: 'flex',
  gap: 10,
  alignItems: 'end',
  margin: '10px 0px'
}))

export const InfoSeparator = styled('div')(() => ({
  flexGrow: 1,
  borderTop: '0.5px dashed #CBCBCB',
  alignSelf: 'center',
  marginTop: '4px'
}))

export const RemovedBadge = styled('span')(() => ({
  fontSize: '11px',
  fontWeight: 500,
  color: theme.palette.error.main,
  backgroundColor: `${theme.palette.error.main}15`,
  padding: '2px 6px',
  borderRadius: '4px',
  display: 'inline-block',
  marginTop: '2px'
}))
